import React, { useState, useEffect } from "react";
import { exportTableToPDF } from "./utils/exportPDF";
import { Link } from "react-router-dom";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const PurchaseOrder = () => {
  const [requisitionList, setRequisitionList] = useState([]);
  const [kitchenName, setFilterDate] = useState("");

  const [kitchens, setKitchens] = useState([]);
  const [itemDetails, setItemDetails] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(requisitionList.length / itemsPerPage);
  const paginatedList = requisitionList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    fetchKitchens();
    fetchRequisitionList();
  }, []);

  const fetchKitchens = async (date = "") => {
    try {
      const url = date
        ? `https://ims-backend.indevconsultancy.in/api/kitchens/?kitchens_name=${date}`
        : `https://ims-backend.indevconsultancy.in/api/kitchens/`;
      const response = await axios.get(url);
      setKitchens(response.data);
    } catch (error) {
      console.error("Error fetching kitchens:", error);
    }
  };

  const fetchRequisitionList = async (date = "") => {
    try {
      const url = date
        ? `https://ims-backend.indevconsultancy.in/api/kitchens/?kitchens_name=${date}`
        : `https://ims-backend.indevconsultancy.in/api/kitchens/`;

      const response = await axios.get(url);
      if (response.data && Array.isArray(response.data)) {
        setRequisitionList(response.data);
      } else {
        setRequisitionList([]);
      }
    } catch (error) {
      console.error("Error fetching requisitions:", error);
      setRequisitionList([]);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (kitchenName) {
      fetchRequisitionList(kitchenName);
    } else {
      fetchRequisitionList();
    }
  };

  const handleClick = (id) => {
    localStorage.setItem("get_kitchen_id", id);
    navigate("/purchaseorderlists");
  };

  const navigate = useNavigate();

  const exportToCSV = () => {
    if (!requisitionList.length) return;

    const headers = ["S.No.", "Kitchen Name", "Kitchen Address"];
    const rows = requisitionList.map((item, index) => [
      index + 1,
      item.kitchen_name,
      item.kitchen_address,
    ]);

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers.join(","), ...rows.map((r) => r.join(","))].join("\n");

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "purchase_order_list.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const exportToPDF = () => {
    if (!requisitionList.length) return alert("No data to export.");
    const headers = ["S.No.", "Kitchen Name", "Kitchen Address"];
    const rows = requisitionList.map((item, index) => [index + 1, item.kitchen_name, item.kitchen_address]);
    exportTableToPDF({ title: "Purchase Order - Kitchens", headers, rows, filename: "purchase_order_list.pdf", filterInfo: `Total: ${rows.length}` });
  };

  return (
    <div className="container-fluid px-2">
      {/* <div className="row">
                <div className="col mt-2">
                    <span className="fs-1"> Purchase Order List</span>
                </div>
                <div className="col">
                    <nav className="py-2" aria-label="breadcrumb">
                        <ol className="breadcrumb justify-content-end">
                            <li className="breadcrumb-item active">Purchase Order List</li>
                            <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        </ol>
                    </nav>
                </div>
            </div> */}

      <div className="row align-items-center justify-content-between py-2">
        <div className="col-md-6 col-4">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb justify-content-start mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Home</Link>
              </li>
            </ol>
          </nav>
        </div>
        <div className="col-md-6 col-8 text-end">
          <span className="fs-1">Purchase Order List</span>
        </div>
      </div>

      <div className="card">
        <div className="card-header border-info">
          <form onSubmit={handleSearch}>
            <div className="row g-3">
              <div className="col-lg">
                <input
                  type="text"
                  placeholder="Search"
                  value={kitchenName}
                  onChange={(e) => setFilterDate(e.target.value)}
                  className="form-control"
                />
              </div>
              <div className="col-lg-2">
                <button type="submit" className="btn btn-primary w-100">
                  Search
                </button>
              </div>
              <div className="col-lg-1">
                <button
                  type="button"
                  onClick={() => {
                    setFilterDate("");
                    fetchRequisitionList(); // fetch all
                  }}
                  className="btn btn-outline-dark w-100"
                >
                  Reset
                </button>
              </div>
            </div>
          </form>
        </div>
        <div className="card-body">
          <div className="row g-0 align-items-center">
            <div className="d-flex justify-content-between">
              <h6 className="fw-bold mb-0">
                Total Kitchen(s): <span>{requisitionList.length}</span>
              </h6>
              <div>
                <button className="btn btn-primary btn-sm mb-1 me-1" onClick={exportToCSV}>
                  <i className="fas fa-file-csv me-1"></i> Export CSV
                </button>
                <button className="btn btn-danger btn-sm mb-1" onClick={exportToPDF}>
                  <i className="fas fa-file-pdf me-1"></i> Export PDF
                </button>
              </div>
            </div>
          </div>

          <div className="table-responsive scrollbar">
            <table className="table text-center table-bordered table-striped fs--1 mb-0">
              <thead className="bg-primary text-white">
                <tr>
                  <th>S.No.</th>
                  <th>Kitchen Name</th>
                  <th>Kitchen Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedList.length === 0 ? (
                  <tr>
                    <td colSpan="3">No data</td>
                  </tr>
                ) : (
                  paginatedList.map((item, index) => {
                    return (
                      <tr key={item.kitchen_id}>
                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                        <td>{item.kitchen_name}</td>
                        <td>{item.kitchen_address}</td>
                        <td>
                          <button
                            className="btn btn-primary"
                            onClick={() => handleClick(item.kitchen_id)}
                          >
                            <i className="fas fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>
            <span>
              Page {currentPage} of {totalPages}
            </span>
            <button
              className="btn btn-outline-primary btn-sm"
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrder;
